module.exports = __webpack_public_path__ + "media/images/lp/achievement4-pc-4d46f84c495937a03b3ce964620f78bb.png";